import getCalendarEventsOverlappingDateRange from './getCalendarEventsOverlappingDateRange';
import { CalendarEvent } from 'mini-calendar-event-types';
import { getCalendarInfoStore, getDateRangeStore } from '../store/store';

/**
 * Utility method that filters the events that can be added to cache.
 * @param calendarEvents The list of calendar events to be inserted in events cache
 */
export default function filterCacheableCalendarEvents(
    calendarEvents: CalendarEvent[]
): CalendarEvent[] {
    // filter the selected calendar events.
    const calendars = getCalendarInfoStore().getAllCalendarInfo();
    const selectedCalendarEvents = calendarEvents.filter(
        e => e.ParentFolderId && calendars.find(c => c.calculatedFolderId === e.ParentFolderId.Id)
    );
    // filter the events if they are in valid date range of cache.
    return getCalendarEventsOverlappingDateRange(
        selectedCalendarEvents,
        getDateRangeStore().getDateRange()
    );
}
